// ─────────────────────────────────────────────────────────────────────────────
// React entry point.
//
// Mounts <App /> into #root. That is the only responsibility of this file;
// everything else (routing, state, data fetching) lives in App.tsx and below.
//
// StrictMode is intentional. It double-invokes effects and state updates in
// development to surface bugs around cleanup, race conditions, and stale
// closures — exactly the class of bugs that a polling checkout page is prone
// to if we're not careful. StrictMode is a no-op in production.
// ─────────────────────────────────────────────────────────────────────────────

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/base.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  // Fail-loud: if #root isn't in the DOM, index.html is wrong. Better to
  // throw at boot than render to nowhere and look blank to the user.
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
